import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-higher.svg";
import * as styles from "./Icon.module.scss";

type IconHigherProps = React.SVGProps<SVGSVGElement>;

export const IconHigher = ({ className, ...props }: IconHigherProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
